module.exports = " <div class=horizontal-collapse uib-collapse=menuStatus.isCollapsed horizontal> <uib-accordion close-others=false> <div ng-repeat=\"node in nodeList.children|orderBy: 'element'\"> <situation-record-nav-bar-detail node=node select-call-back-fn=onSelectCallBackFn></situation-record-nav-bar-detail> </div> </uib-accordion> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/situationRecordNavBar/situationRecordNavBar.html
// module id = 263
// module chunks = 0